export default {"src":"/_next/static/media/bell.d26124af.svg","height":512,"width":512,"blurWidth":0,"blurHeight":0};